import React, {Fragment, useEffect, useState, useRef, useContext} from "react" ;
import {Route, Switch} from "react-router-dom";
import phpVars from 'phpVars';

import {
    PATH_HOME_ROOT,
    PATH_MESSAGING_ROOT,
    PATH_LETTERBOX_ROOT,
    PATH_CHILD_ROOT,
    PATH_TEAM_ROOT,
    PATH_POSTS_ROOT,
    PATH_DASHBOARD_ROOT,
    PATH_USERS_ROOT,
    PATH_CONTACT_ROOT,
    PATH_RESOURCES_ROOT,
    PATH_ADMIN_ROOT,
    PATH_MY_CONTRIBUTORS_ROOT,
    PATH_APPROVALS_ROOT,
    PATH_SAFEGUARDING_ROOT,
    PATH_PRIVATE_MESSAGING_ROOT
} from "./routePaths";

import WieldySidebar from "root/Wieldy/Sidebar/WieldySidebar";
import WieldyPageFooter from "root/Wieldy/WieldyPageFooter";
import WieldyPageHeader from "root/Wieldy/WieldyPageHeader";

import WieldyApplicationModuleMessaging from "./ApplicationModules/Messaging/WieldyApplicationModuleMessaging";
import WieldyApplicationModuleLetterbox from "root/Wieldy/ApplicationModules/Letterbox/WieldyApplicationModuleLetterbox";
import WieldyApplicationModuleChild from "root/Wieldy/ApplicationModules/Child/WieldyApplicationModuleChild";
import WieldyApplicationModulePosts from "root/Wieldy/ApplicationModules/Posts/WieldyApplicationModulePosts";
import WieldyApplicationModuleTeam from "root/Wieldy/ApplicationModules/Team/WieldyApplicationModuleTeam";
import ChildProvider from "root/contexts/ChildProvider";
import WieldyApplicationModuleOrgDash from "root/Wieldy/ApplicationModules/OrganisationDashboard/WieldyApplicationModuleOrgDash";
import WieldyApplicationModuleUsers from "root/Wieldy/ApplicationModules/Users/WieldyApplicationModuleUsers";
import WieldyApplicationModuleResources from "root/Wieldy/ApplicationModules/Resources/WieldyApplicationModuleResources";
import WieldyApplicationModuleContact from "root/Wieldy/ApplicationModules/Contact/WieldyApplicationModuleContact";
import {useIdleTimer} from "react-idle-timer";
import {APP_TIMEOUT} from "root/DataFunctions/Constants";
import WieldyApplicationModuleAdmin from "root/Wieldy/ApplicationModules/Admin/WieldyApplicationModuleAdmin";
import WieldyApplicationModuleMyContributors from "root/Wieldy/ApplicationModules/MyContributors/WieldyApplicationModuleMyContributors";
import WieldyApplicationModuleApprovals
    from "root/Wieldy/ApplicationModules/Approvals/WieldyApplicationModuleApprovals";
import {ApplicationTypes, doesUserHaveApplication} from "root/DataFunctions/PageContentRoles";
import GlobalContext from "root/contexts/GlobalContext";
import WieldyApplicationModuleSafeguarding
    from "root/Wieldy/ApplicationModules/Safeguarding/WieldyApplicationModuleSafeguarding";
import WieldyApplicationModulePrivateMessaging
    from "root/Wieldy/ApplicationModules/PrivateMessaging/WieldyApplicationModulePrivateMessaging";

const WieldyComponent = (props) =>
{
    const dtRootElement = useRef(null);
    const footerElement = useRef ( null ) ;
    const headerElement = useRef ( null ) ;
    const dtContentElement = useRef(null);

    const MODULE_SIDEBAR_WIDTH = 230 ;

    const globals = useContext(GlobalContext);

    const doesUserHaveletterbox = doesUserHaveApplication(ApplicationTypes.POSTBOX, globals.userType) || doesUserHaveApplication(ApplicationTypes.POSTBOX_APPROVER, globals.userType) ;


    const onIdle = () => {
        console.log ( "Timeout!!") ;

        window.location.replace(phpVars.logout_script + '&reason=timeout' );
    }

    const onActive = (event) => {
        console.log ( "Active!!") ;
    }

    const { start } = useIdleTimer({
        timeout: APP_TIMEOUT,
        startManually: true,
        onIdle,
        onActive })

    const calcModuleHeight = () =>
    {
        if ( dtRootElement.current != null )
        {
            return dtRootElement.current.clientHeight - ( headerElement.current.clientHeight + footerElement.current.clientHeight )
        }
        else
        {
            return  0 ;
        }
    }

    const calcModuleContentWidth = () =>
    {
        if ( dtContentElement.current != null )
        {
            return dtContentElement.current.clientWidth - MODULE_SIDEBAR_WIDTH ;
        }
        else
        {
            return  0 ;
        }
    }


    const [ windowHeight, setWindowHeight ] = useState ( calcModuleHeight() ) ;
    const [ moduleContentWidth, setModuleContentWidth ] = useState ( calcModuleContentWidth() ) ;

    const calcNavbarHeight = () =>
    {
        if ( dtContentElement.current != null )
        {
            return footerElement.current.clientHeight + windowHeight
        }
        else
        {
            return  0 ;
        }
    }

    useEffect(() => {

        function debounce(fn, ms) {

            let timer

            return _ => {
                clearTimeout(timer)

                timer = setTimeout(_ => {

                    timer = null
                    fn.apply(this, arguments)

                }, ms)
            };
        }

        const debouncedHandleResize = debounce(function handleResize()
        {
            setWindowHeight(  calcModuleHeight()  ) ;
            setModuleContentWidth(calcModuleContentWidth() );

        }, 250)

        window.addEventListener('resize', debouncedHandleResize)

        debouncedHandleResize( null );

        return _ => {
            window.removeEventListener('resize', debouncedHandleResize)
        }

    })

    useEffect(() => {
        console.log ( "Initial Root Height = " + dtRootElement.current.clientHeight );

        setWindowHeight ( calcModuleHeight()) ;
        setModuleContentWidth(calcModuleContentWidth() );

        // Start the inactivity timer
        start() ;
    }, []);

    const [ brandToolActive, setBrandToolActive ] = useState ( false ) ;

    const brandToolClass = brandToolActive ? ' active' : '' ;
    const foldedClassName = 'dt-sidebar--folded' ;

    const toggleBrandTool = () =>
    {
        if ( brandToolActive === false )
        {
            document.body.classList.add(foldedClassName);
        }
        else
        {
            document.body.classList.remove(foldedClassName);
        }

        setBrandToolActive(brandToolActive => !brandToolActive);
    }

    const brandTool = () =>
    {
        return (
            <div onClick={toggleBrandTool} className={"dt-brand__tool"+brandToolClass} data-toggle="main-sidebar">
                <i className="icon icon-xl icon-menu-fold d-none d-lg-inline-block"/>
                <i className="icon icon-xl icon-menu d-lg-none"/>
            </div>
        )
    }

    const navBarHeight = calcNavbarHeight() ;

    return (
        <Fragment>
            <div ref={dtRootElement} className="dt-root">

                <WieldyPageHeader ref={headerElement} brandTool={brandTool}/>

                <main className="dt-main">
                    <ChildProvider>

                        <aside id="main-sidebar" className="dt-sidebar" style={{backgroundColor: '#F4F3F4', height: navBarHeight, overflow: 'scroll'}}>
                            <div className="dt-sidebar__container">
                                <WieldySidebar height={windowHeight}/>
                            </div>
                        </aside>

                        <div className="dt-content-wrapper" >
                            <div ref={dtContentElement} className="dt-content">
                                <Switch>
                                    <Route path={PATH_LETTERBOX_ROOT} render={(props) => <WieldyApplicationModuleLetterbox {...props} height={windowHeight} width={moduleContentWidth}/>}/>
                                    {phpVars.has_lifestory && <Route path={PATH_POSTS_ROOT} render={(props) => <WieldyApplicationModulePosts {...props} height={windowHeight} width={moduleContentWidth}/>}/>}
                                    <Route path={PATH_MESSAGING_ROOT} render={(props) => <WieldyApplicationModuleMessaging {...props} height={windowHeight} width={moduleContentWidth}/>}/>
                                    <Route path={PATH_CHILD_ROOT} render={(props) => <WieldyApplicationModuleChild {...props} height={windowHeight} width={moduleContentWidth}/>}/>
                                    <Route path={PATH_CONTACT_ROOT} render={(props) => <WieldyApplicationModuleContact {...props} height={windowHeight} width={moduleContentWidth}/>}/>
                                    <Route path={PATH_TEAM_ROOT} render={(props) => <WieldyApplicationModuleTeam {...props} height={windowHeight} width={moduleContentWidth}/>}/>
                                    <Route path={PATH_DASHBOARD_ROOT} render={(props) => <WieldyApplicationModuleOrgDash {...props} height={windowHeight} width={moduleContentWidth}/>}/>
                                    <Route path={PATH_USERS_ROOT} render={(props) => <WieldyApplicationModuleUsers {...props} height={windowHeight} width={moduleContentWidth}/>}/>
                                    <Route path={PATH_ADMIN_ROOT} render={(props) => <WieldyApplicationModuleAdmin{...props} height={windowHeight} width={moduleContentWidth}/>}/>
                                    <Route path={PATH_RESOURCES_ROOT} render={(props) => <WieldyApplicationModuleResources {...props} height={windowHeight} width={moduleContentWidth}/>}/>
                                    <Route path={PATH_MY_CONTRIBUTORS_ROOT} render={(props) => <WieldyApplicationModuleMyContributors {...props} height={windowHeight} width={moduleContentWidth}/>}/>
                                    <Route path={PATH_APPROVALS_ROOT} render={(props) => <WieldyApplicationModuleApprovals {...props} height={windowHeight} width={moduleContentWidth}/>}/>
                                    <Route path={PATH_SAFEGUARDING_ROOT} render={(props) => <WieldyApplicationModuleSafeguarding {...props} height={windowHeight} width={moduleContentWidth}/>}/>
                                    <Route path={PATH_PRIVATE_MESSAGING_ROOT} render={(props) => <WieldyApplicationModulePrivateMessaging {...props} height={windowHeight} width={moduleContentWidth}/>}/>
                                    { doesUserHaveApplication(ApplicationTypes.SYSADMIN, globals.userType) && <Route exact path={PATH_HOME_ROOT} render={(props) => <WieldyApplicationModuleAdmin{...props} height={windowHeight} width={moduleContentWidth}/>}/>}
                                    {+globals.isEditor === 1 && !doesUserHaveletterbox && <Route exact path={PATH_HOME_ROOT} render={(props) => <WieldyApplicationModuleApprovals{...props} height={windowHeight} width={moduleContentWidth}/>}/>}
                                    {(doesUserHaveApplication(ApplicationTypes.POSTBOX, globals.userType)
                                    || doesUserHaveApplication(ApplicationTypes.POSTBOX_APPROVER, globals.userType))&& <Route exact path={PATH_HOME_ROOT} render={(props) => <WieldyApplicationModuleLetterbox{...props} height={windowHeight} width={moduleContentWidth}/>}/>}
                                    {+globals.isEditor !== 1 && doesUserHaveApplication(ApplicationTypes.MESSAGING, globals.userType) && <Route exact path={PATH_HOME_ROOT} render={(props) => <WieldyApplicationModuleMessaging{...props} height={windowHeight} width={moduleContentWidth}/>}/>}


                                </Switch>
                            </div>

                            <WieldyPageFooter ref={footerElement}/>

                        </div>
                    </ChildProvider>

                </main>
            </div>
        </Fragment>
    );
}

export default WieldyComponent;
